import { Component, inject } from "@angular/core";
import { FormGroup, FormControl, ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { StepperComponent } from "../components/stepper/stepper.component";
import { StepComponent } from "../components/stepper/step.component";
import { DatePickerComponent } from "../components/date-picker/date-picker.component";
import { TagComponent, TagOption } from "../components/tag/tag.component";
import { TagListComponent } from "../components/tag/tag-list.component";
import { SnackbarService } from "../components/snackbar/snackbar.service";
import { MatProgressBar } from "@angular/material/progress-bar";
import { DateRangeBarComponent } from "../components/date-range-bar/date-range-bar.component";
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { ButtonComponent, ButtonVariant } from "@sxm-content-creators/tools-ds";
import { ImageUploadComponent } from "../components/image-upload/image-upload.component";
import { ThemeAssetUploadResponse } from "../admin/themes/models/theme.model";
import { ConfirmModalComponent, ConfirmModalData } from "../components/confirm-modal/confirm-modal.component";

@Component({
    selector: "app-gallery",
    templateUrl: "./gallery.component.html",
    styleUrl: "./gallery.component.scss",
    standalone: true,
    imports: [
        StepperComponent,
        StepComponent,
        DatePickerComponent,
        FormsModule,
        ReactiveFormsModule,
        TagComponent,
        TagListComponent,
        MatButtonModule,
        TagListComponent,
        MatProgressBar,
        DateRangeBarComponent,
        MatRadioGroup,
        MatRadioButton,
        ButtonComponent,
        ImageUploadComponent
    ]
})
export class GalleryComponent {
    private readonly snackbarService = inject(SnackbarService);
    private readonly dialog = inject(MatDialog);

    protected readonly ButtonVariant = ButtonVariant;

    dateA: Date | null = new Date("2026-06-08T14:30:00Z");
    dateB: Date | null = null;
    form = new FormGroup({
        startDate: new FormControl<Date | null>(new Date("2026-05-08T14:30:00Z")),
        endDate: new FormControl<Date | null>(null),
        tags: new FormControl<TagOption<{ value: string; filterGroup: string }>[]>([
            { value: { value: "kreator", filterGroup: "tagCategoryA" }, label: "Kreator" },
            { value: { value: "trash-metal", filterGroup: "tagCategoryB" }, label: "Thrash Metal" },
            { value: { value: "60+", filterGroup: "Score" }, label: "60+" },
            { value: { value: "Score", filterGroup: "Column" }, label: "Column: Score" },
            { value: { value: "Take Summary", filterGroup: "Column" }, label: "Column: Take Summary" }
        ])
    });

    tags: TagOption<string>[] = [
        { value: "kreator", label: "Kreator" },
        { value: "collaborations", label: "Collaborations" },
        { value: "thrash-metal", label: "Thrash Metal" },
        { value: "krushers", label: "Krushers of the World" }
    ];

    readonly tag: TagOption<string> = { value: "tag", label: "tag" };

    startDate = new Date();
    endDate = new Date(new Date().setDate(new Date().getDate() + 10));
    pastStartDate = new Date(new Date().setDate(new Date().getDate() - 1));
    laterEndDate = new Date(new Date().setDate(new Date().getDate() + 13));

    onTagClick(tag: TagOption<string>): void {
        console.log("tag click event", tag);
    }

    onTagRemoved(tag: TagOption<string>): void {
        console.log("tag remove event", tag);
    }

    showSuccess(): void {
        this.snackbarService.show("Interactive published.", "success");
    }

    showError(): void {
        this.snackbarService.show("Uh oh, something's gone wrong.", "error");
    }

    onFooterCancel(): void {
        this.snackbarService.show("Cancelled.", "error");
    }

    onFooterSave(): void {
        this.snackbarService.show("Saved.", "success");
    }

    onImageUploaded(asset: ThemeAssetUploadResponse): void {
        this.snackbarService.show(`Uploaded: ${asset.key}`, "success");
    }

    openConfirmModal(): void {
        this.openConfirm({
            title: "Confirm Modal",
            message: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
            confirmLabel: "Confirm"
        });
    }

    openDangerConfirmModal(): void {
        this.openConfirm({
            title: "Dangerous Confirm Modal",
            message: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
            confirmLabel: "Confirm",
            danger: true
        });
    }

    private openConfirm(data: ConfirmModalData): void {
        this.dialog
            .open<ConfirmModalComponent, ConfirmModalData, boolean>(ConfirmModalComponent, { data })
            .afterClosed()
            .subscribe(confirmed => this.snackbarService.show(confirmed ? "Confirmed." : "Cancelled.", "success"));
    }
}
